export default function Exams() {
    return(
        <div>
            App Side - Exams
        </div>
    );
}